export const TAB = {
  plans: "plans",
  properties: "Properties"
};
